import React, { useContext, useEffect, useMemo, useState } from "react";
import style from "./Navbar.module.scss";
import logo from "../../assets/logo.svg";
import {
  FaBars,
  FaChevronDown,
  FaPhone,
  FaChevronRight,
  FaTimes,
  FaYoutube,
  FaFacebook,
} from "react-icons/fa";
import {} from "react-router-dom";
import { SessionContext } from "@appidea/rs.bs.customers.react";
import { PagesRegistryContext, Animator } from "@appidea/react-scroll-motion";
import {
  logoBarKeyframes,
  NavbarMovementBarAnimation,
} from "./Navbar.animation";
import NavbarButton from "./NavbarButton";
import { LogoText } from "../Logo";
import Possibilities from "./Possibilities";
import { Message } from "@messageformat/react";
import LocaleContext from "../../context/Locale";

const MobileNavbarButtton = ({ children, ...props }) => {
  return (
    <button className={style.mobileMenuItem} {...props}>
      {children} <FaChevronRight />
    </button>
  );
};

const AnimationWrapper = ({ children }) => {
  const { registerAnimation } = useContext(PagesRegistryContext);

  useEffect(() => {
    registerAnimation("navbarMovementBar", NavbarMovementBarAnimation);
  }, [registerAnimation]);

  return (
    <Animator
      relativeTo="viewport"
      keyframes={logoBarKeyframes}
      className={style.headerLogoBar}
    >
      {children}
    </Animator>
  );
};

const NoAnimationWrapper = ({ children }) => {
  return <div className={style.headerLogoBar}>{children}</div>;
};

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, updateLanguage } = useContext(LocaleContext);
  const [possibilitiesOpen, setPossibilitiesOpen] = useState(false);

  const [isMainPage, setIsMainPage] = useState(false);
  useEffect(() => {
    const listener = () => {
      setIsMainPage(window.location.pathname === "/");
    };

    listener();
    window.addEventListener("popstate", listener);
    return () => window.removeEventListener("popstate", listener);
  }, []);

  const BarWrapper = isMainPage ? AnimationWrapper : NoAnimationWrapper;

  return (
    <>
      <header className={style.navbar}>
        <BarWrapper>
          <div className={style.headerLogoBarInner}>
            <a href="/" className={style.logoZone}>
              <LogoText />
            </a>
          </div>

          <div className={style.headerInner}>
            <button
              className={style.mobileMenuButton}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <FaBars size={30} />
            </button>
            <div className={style.buttons}>
              <div className={style.buttonsLeft}>
                <NavbarButton
                  isMainPage={isMainPage}
                  onClick={() => setPossibilitiesOpen(!possibilitiesOpen)}
                  icon={FaChevronDown}
                >
                  <Message id="navbar.menu.possibilities" />
                </NavbarButton>
                <NavbarButton
                  isMainPage={isMainPage}
                  icon={FaChevronDown}
                  onClick={() => (window.location = "/cennik")}
                >
                  <Message id="navbar.pricing" />
                </NavbarButton>
                <NavbarButton
                  isMainPage={isMainPage}
                  icon={FaChevronDown}
                  onClick={() => (window.location = "/sprzet")}
                >
                  <Message id="navbar.hardware" />
                </NavbarButton>
              </div>

              <div className={style.buttonsRight}>
                <NavbarButton
                  isMainPage={isMainPage}
                  onClick={() => (window.location = "/kontakt")}
                  icon={FaPhone}
                >
                  <Message id="navbar.contact" />
                </NavbarButton>
                <button
                  onClick={() =>
                    updateLanguage(language === "pl-PL" ? "en-GB" : "pl-PL")
                  }
                  style={{
                    background: "none",
                    color: "white",
                    border: "none",
                    fontSize: 24,
                  }}
                >
                  {language === "pl-PL" ? "🇬🇧" : "🇵🇱"}
                </button>
              </div>
            </div>
          </div>
        </BarWrapper>
      </header>

      {menuOpen && (
        <div className={style.mobileMenu}>
          <MobileNavbarButtton
            onClick={() =>
              (window.location = "/chmurowy-system-zarzadzania-sprzedaza")
            }
          >
            <Message id="navbar.menu.cloud" />
          </MobileNavbarButtton>
          <MobileNavbarButtton
            onClick={() =>
              (window.location = "/kioski-samoobslugowe-z-chatem-gpt")
            }
          >
            <Message id="navbar.menu.kiosks" />
          </MobileNavbarButtton>
          <MobileNavbarButtton
            onClick={() => (window.location = "/ai-w-twoim-punkcie-sprzedazy")}
          >
            <Message id="navbar.menu.rapidshopAI" />
          </MobileNavbarButtton>
          <MobileNavbarButtton
            onClick={() => (window.location = "/aplikacja-sprzedazowa-android")}
          >
            <Message id="navbar.menu.pos" />
          </MobileNavbarButtton>
          <MobileNavbarButtton
            onClick={() => (window.location = "/system-ekranow-kuchennych")}
          >
            <Message id="navbar.menu.kds" />
          </MobileNavbarButtton>
          <MobileNavbarButtton
            onClick={() => (window.location = "/system-promocji-i-rabatow")}
          >
            <Message id="navbar.menu.discounts" />
          </MobileNavbarButtton>
          <MobileNavbarButtton
            onClick={() => (window.location = "/latwe-zarzadzanie-sprzetem")}
          >
            <Message id="navbar.menu.managemenr" />
          </MobileNavbarButtton>
          <MobileNavbarButtton onClick={() => (window.location = "/cennik")}>
            <Message id="navbar.pricing" />
          </MobileNavbarButtton>
          <MobileNavbarButtton onClick={() => (window.location = "/sprzet")}>
            <Message id="navbar.hardware" />
          </MobileNavbarButtton>
          <MobileNavbarButtton onClick={() => (window.location = "/kontakt")}>
            <Message id="navbar.contact" />
          </MobileNavbarButtton>

          <div className={style.mobileSocialButtons}>
            <a
              href="https://www.youtube.com/@rapidshop_ai"
              target="_blank"
              rel="noopener noreferrer"
              className={style.mobileSocialIcon}
              aria-label="YouTube"
            >
              <FaYoutube size={20} />
            </a>
            <a
              href="https://www.facebook.com/rapidshopapp"
              target="_blank"
              rel="noopener noreferrer"
              className={style.mobileSocialIcon}
              aria-label="Facebook"
            >
              <FaFacebook size={20} />
            </a>
          </div>

          <button
            className={style.mobileMenuClose}
            onClick={() => setMenuOpen(false)}
          >
            <FaTimes size={30} />
          </button>
        </div>
      )}

      <Possibilities
        open={possibilitiesOpen}
        isMainPage={isMainPage}
        onClose={() => setPossibilitiesOpen(false)}
      />
    </>
  );
};

export default Navbar;
